export default "__VITE_ASSET__60bf7dc0__"